import { Flex, Placement, PlacementArea, Text } from '@bitrise/bitkit';
import { SeriesPointXY, useReferenceElement } from '@bitrise/bitviz';
import React, { FunctionComponent } from 'react';
import getFormattedValue from '../../../utils/metric/getFormattedValue';

type Props = {
  point: SeriesPointXY | null;
  title: string;
};

const OverviewLiveUsersTooltip: FunctionComponent<Props> = ({ point, title }) => {
  const referenceElement = useReferenceElement(point);

  if (!referenceElement || !point) {
    return null;
  }

  return (
    <Placement
      backgroundColor="black"
      borderRadius="x1"
      minWidth="8rem"
      placement="top"
      referenceElement={referenceElement}
      style={{ pointerEvents: 'none' }}
      textColor="gray-1"
      visible={!!point}
    >
      {() => (
        <PlacementArea padding="x3" withArrow>
          <Flex direction="vertical" gap="x1">
            <Flex>
              <Text config="9" align="middle">
                {title}
              </Text>
            </Flex>

            <Flex>
              <Text align="middle">{getFormattedValue('1', point.y)}</Text>
            </Flex>
          </Flex>
        </PlacementArea>
      )}
    </Placement>
  );
};

export default OverviewLiveUsersTooltip;
